

















































































































































import { Component } from "vue-property-decorator";

import { BaseGridComponent, GridPagerCpt } from "@/core/components";
import {
  DashboardCollectionModel,
  PagedCollectionFilter,
  DashboardFilterModel,
  FileDownloadModel,
} from "@/core/models";
import { CompanyService, WorkshopService, Utils, QuestionnaireService, DownloadService } from "@/core/services";
import { DashboardGridFiltersCpt, WorkshopStatusCpt, RevStatusCpt, FollowUpStatusCpt } from "./";

@Component({
  components: {
    GridPagerCpt,
    DashboardGridFiltersCpt,
    WorkshopStatusCpt,
    RevStatusCpt,
    FollowUpStatusCpt,
  },
})
export default class DashboardGridCpt extends BaseGridComponent<DashboardCollectionModel, DashboardFilterModel> {
  filter = {
    sectorId: 0,
    companyName: "",
  } as PagedCollectionFilter & DashboardFilterModel;

  downloadingReport = false;

  async created() {
    this.initializeFilters();
    this.load();
  }

  private async downloadFollowUpReport(companyId: number) {
    this.downloadingReport = true;
    try {
      await CompanyService.downloadFollowUpReport(companyId);
    } finally {
      this.downloadingReport = false;
    }
  }

  private async downloadSkillsPlan(companyId: number) {
    this.downloadingReport = true;
    try {
      const response: FileDownloadModel = await QuestionnaireService.downloadCriticalSkillsReportForCompany(companyId);
      await QuestionnaireService.generateCriticalSkillsFile(response);
    } finally {
      this.downloadingReport = false;
    }
  }
  private filterUpdated(filter: PagedCollectionFilter & DashboardFilterModel) {
    this.filter = filter;
    this.filter.page = 1;
    this.load();
  }

  private async downloadSosReport(filter: PagedCollectionFilter & DashboardFilterModel) {
    this.downloadingReport = true;
    try {
      const response: FileDownloadModel = await WorkshopService.downloadSosReport(filter);

      const blob = new Blob([Utils.getArrayBuffer(atob(response.data))], { type: response.contentType });
      DownloadService.download(blob, response.fileName);
    } finally {
      this.downloadingReport = false;
    }
  }

  private async downloadSkillsConsultantReport(filter: PagedCollectionFilter & DashboardFilterModel) {
    this.downloadingReport = true;
    try {
      const response: FileDownloadModel = await WorkshopService.downloadSkillsConsultantReport(this.filter);

      const blob = new Blob([Utils.getArrayBuffer(atob(response.data))], { type: response.contentType });
      DownloadService.download(blob, response.fileName);
    } finally {
      this.downloadingReport = false;
    }
  }

  private load() {
    this.initialize(filter => CompanyService.dashboardFilter(filter), "dashboard", this.filter);
  }

  private initializeFilters() {
    if (this.filter) {
      const query = this.$route.query as any;
      this.filter.regionId = !!query.regionId ? parseInt(query.regionId, 10) : 0;
      this.filter.countyId = !!query.countyId ? parseInt(query.countyId, 10) : 0;
      this.filter.sectorId = !!query.sectorId ? parseInt(query.sectorId, 10) : 0;
      this.filter.workshopStatusId = !!query.workshopStatusId ? parseInt(query.workshopStatusId, 10) : 0;
      this.filter.search = query.search || "";
      this.filter.companyName = query.companyName || "";
      this.filter.startDate = query.startDate ? new Date(query.startDate) : (null as any);
      this.filter.endDate = query.endDate ? new Date(query.endDate) : (null as any);
      this.filter.sortBy = query.sortBy || "workshop.eventDate";
      this.filter.sortOperator = query.sortOperator || "desc";

      const start = new Date();
      start.setDate(start.getDate() - 7);
      if (!this.filter.startDate) {
        this.filter.startDate = start;
      }

      if (!this.filter.endDate) {
        const end = new Date();
        end.setDate(start.getDate() + 14);
        this.filter.endDate = end;
      }
    }
  }
}
